/**
 * @file Status.jsx
 * @description Displays onboarding progress and status information
 *
 * @section Responsibilities
 * - Show onboarding completion status
 * - Display progress indicators
 * - List pending requirements
 * - Provide next steps guidance
 * - Show estimated completion time
 * - Handle status updates
 *
 * @section Dependencies
 * - ProgressTracker: Onboarding progress management
 * - RequirementService: Document and requirement status
 * - TimelineService: Estimated completion calculations
 * - NotificationSystem: Status updates
 *
 * @section Integration Points
 * - Onboarding API: Progress tracking
 * - Document Service: Requirement status
 * - Notification System: Status updates
 * - Navigation System: Next steps routing
 *
 * @section State Management
 * - progress: Current completion status
 * - requirements: Pending requirements
 * - timeline: Estimated completion
 * - updates: Recent status changes
 *
 * @section Events
 * - onStatusUpdate: Status changes
 * - onRequirementComplete: Requirement completion
 * - onNextStep: Navigation to next step
 * - onRefresh: Status refresh
 *
 * @section Props
 * @prop {Object} currentStatus - Current onboarding status
 * @prop {Array} requirements - List of pending requirements
 * @prop {Function} onRefresh - Status refresh callback
 * @prop {Boolean} autoUpdate - Controls automatic updates
 */

import React, { useEffect, useState } from "react";
import BallsBackground from "../../components/BallsBackground";
import Request from "../../utils/fetchUtils";
import { useParams } from "react-router-dom";

const applicationTypes = [
  {
    text: "Cash",
    value: "CASH",
  },
  {
    text: "Margin",
    value: "MARGIN",
  },
  {
    text: "IRA",
    value: "IRA",
  },
];

function Status() {
  const { applicationId } = useParams();

  const [application, setApplicantion] = useState({
    id: "",
    email: "",
    name: "",
    status: "",
    createdAt: "",
  });

  const fetchApplication = async () => {
    const res = await Request(`/trading/application/${applicationId}`);

    if (res.statusCode == 200) {
      setApplicantion(res.body);
    }
  };

  useEffect(() => {
    fetchApplication();
  }, []);

  return (
    <div className="your-profile">
      <BallsBackground>
        <div className="content container shadow1">
          <div className="progress-bar">
            <div className="progress"></div>
            <div className="step active">
              <div className="title">
                <div className="number">
                  <span>1</span>
                </div>
                <p>Your profile</p>
              </div>
            </div>
            <div className="step">
              <div className="title">
                <div className="number">
                  <span>2</span>
                </div>
                <p>Agreements</p>
              </div>
            </div>
            <div className="step">
              <div className="title">
                <div className="number">
                  <span>3</span>
                </div>
                <p>Documents</p>
              </div>
            </div>
          </div>
          <div className="inner-content">
            <div className="heading">
              <h1 className="title">Your application</h1>
              <p className="description">ID: {application.id}</p>
            </div>
            <div style={{}}>
              <p className="subtitle">Applicant Information</p>
              <p
                style={{ color: "#fff", marginBottom: 0, marginTop: 6 }}
                className="description"
              >
                {application.name}
              </p>
              <p
                style={{ color: "#fff", marginBottom: 0, marginTop: 6 }}
                className="description"
              >
                {application.createdAt}
              </p>
              <p
                style={{
                  color: "#fff",
                  marginBottom: 0,
                  marginTop: 6,
                  width: 120,
                  textAlign: "center",
                  padding: 6,
                  borderRadius: 6,
                  border: "solid 2px #17b7a8",
                }}
                className="description"
              >
                {application.status}
              </p>
            </div>
          </div>
        </div>
      </BallsBackground>
    </div>
  );
}

export default Status;
